<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                      <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                       &nbsp;&nbsp;&nbsp;
                      <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("userOmsAccessEdit") }}</h6>
                      <button
                        class="btn btn-default btn-sm float-end"
                        @click="resetForm"
                        type="button"
                      >
                      <i class="link-icon" data-feather="repeat"></i>
                        {{ $t("resetFormTxt") }}
                      </button>
                </div>
                <div class="card-body">
      

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                     
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('usernameTxt')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        
                         <v-select
                          :options="fetchUser"
                          v-model="selectedUser"
                          label="username"
                          return-object
                          @search="asyncSearchUser"
                        ></v-select>

                        <div v-if="errors.user_id">
                          <div
                            v-for="error in errors.user_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('company_code')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                       
                         <v-select
                          :options="fetchCompany"
                          v-model="selectedCompany"
                          label="code"
                          return-object
                          @search="asyncSearchCompany"
                          @input="setSelectedCompany"
                        ></v-select>

                        <div v-if="errors.datas">
                          <div
                            v-for="error in errors.datas"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('fulfillment_code')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                       
                       <vue-good-table
                        :columns="columns"
                        :rows="rowsSelectedCompany"
                        :search-options="{
                            enabled: true
                        }">
                        </vue-good-table>

                     
                      </div>
                    </div>
 
                   
                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div> <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "UserOmsEdit",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      fetchSystemCode:[],
      fetchCompany:[],
      fetchUser:[],
      company_type:"",
      selectedCompany:{},
      selectedUser:{},
      userData: "",
      userRole: "",
      companyCode: "",
      forms: { fulfillments: "", user_id: "" , customer:"" },
      rowsSelectedCompany:[],
      columns: [
        {
          label: this.$t("fulfillment_center_id"),
          field: "fulfillment_center_id",
        },
        {
          label: this.$t("fulfillment_code"),
          field: "fulfillment_code",
        },
        {
          label: this.$t("fulfillment_name"),
          field: "fulfillment_name",
        },
      ],
    };
  },
  watch: {
    
  },
  methods: { 

    setSelectedCompany(value){
          const baseURI = this.$settings.endPointFluxOms + "v2/customer-fulfillment/detail-by-customer/"+value.customer_id;
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
           this.rowsSelectedCompany=response.data.datas;
        }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
          this.error(this.$t("check_internet_connection_txt"));
          
        }else{

          if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 401) {
                  this.logout();
              } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
            }

        }
      });
    },
 
    asyncSearchCompany(ev){
      const baseURI = this.$settings.endPointFluxOms + "v2/customer/index?code="+ev;
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
           this.fetchCompany=response.data.datas.data;
        }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
          this.error(this.$t("check_internet_connection_txt"));
          
        }else{

          if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 401) {
                  this.logout();
              } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
            }

        }
      });
    },
 
    asyncSearchUser(ev){
      const baseURI = this.$settings.endPoint + "user?username="+ev;
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
           this.fetchUser=response.data.datas.data;
        }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
          this.error(this.$t("check_internet_connection_txt"));
          
        }else{

          if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 401) {
                  this.logout();
              } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
            }

        }
      });
    },

    resetForm() {
      this.forms.fulfillments = "";
      this.forms.customer = "";
      this.forms.user_id = "";


    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.userData       = userDatas.sub;
      this.userRole       = userDatas.sub.role;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'UserOMSMappingController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_update){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    backForm() {
       window.location.href = "/user-oms";
    },


    submitData() {
     
      this.isLoading = true;
     
      var params = this.$onBehind(this.$route.params.id);
      this.loadData(params[0]);

      this.forms.user_id        = this.selectedUser.id;
      this.forms.customer       = this.selectedCompany;
      this.forms.fulfillments   = this.rowsSelectedCompany;
      
      const baseURI  =  this.$settings.endPoint+"oms-user/update/"+params[0];
      this.$http.patch(baseURI,this.forms,{ timeout: 10000 }).then((response) => {
          this.loading();
          if(response.data.status === 200) {
          //this.resetForm();
              this.isLoading = false;
              this.errors = []; 
                window.location.href = "/user-oms/detail/" + this.$route.params.id + "?status=200&msg=Successfully";
              // this.success('Berhasil');
          }else{
              this.isLoading = false;
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
          }
      }).catch(error => {
            this.loading();
            this.isLoading = false;
            if(error.code == "ECONNABORTED"){
              this.error("Please Check Your Internet Connection");
            }

        if (error.response) {
            if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
            }else if (error.response.status === 401) {
                this.logout();
            } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
            }else if (error.response.status === 500) {
                this.$router.push('/server-error');
            }else{
                this.$router.push('/page-not-found');
            }
          }
          //this.resetForm();
      });
 
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },
    logout(){

        const baseURI = this.$settings.endPoint + "user/logout";
        this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
            
        console.log(response);

        });

        this.$logoutUser();
        window.location.href = '/';
    },
    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    loadData(id) {
      const baseURI = this.$settings.endPoint + "oms-user/detail/"+id;
      this.isLoading = true;
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
 
            
            var dataResponse     = response.data.datas
            this.selectedUser   = {id:dataResponse.user_id , name:dataResponse.name , email:dataResponse.email , username:dataResponse.username}
            var datas           = JSON.parse(dataResponse.datas);
            this.selectedCompany    = datas.customer
            this.rowsSelectedCompany= datas.fulfillments
            this.isLoading = false;
            
        }).catch(error => {
            this.isLoading = false;
          if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
          }else{

                if (error.response) {
                  if(error.response.status === 422) {
                          this.errors = error.response.data.errors;
                          this.resultError(error.response.data.errors);
                  }else if (error.response.status === 401) {
                      this.logout();
                  } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                  }else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                  }else{
                      this.$router.push('/page-not-found');
                  }
                }
          }
        });
    },
 
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();

      var params = this.$onBehind(this.$route.params.id);
      this.loadData(params[0]);
  },
};
</script>
<style scoped>
.blur-content{
  filter: blur(5px); 
}
</style>